import axios from "axios";
import { setToast, ShowWarning } from "./store/actions/configActions";
import constants from "./constants.json";
import { APP_NAME, APP_PATH } from "./appConfig";

export const parseCSV = (csv) => {
    const rows = csv.split("\n");
    const headers = rows[0].split(",").map(header => header.replace(/"/g, "").trim());
    const json = rows.slice(1).filter(val => val !== "").map(row => {
        const values = row.split(",").map(value => value.replace(/"/g, "").trim());
        return headers.reduce((obj, header, index) => {
            obj[header] = values[index] === "NULL" ? null : values[index];
            return obj;
        }, {});
    });
    return json;
}

export function validateInput(input) {
    const regex = /^[0-9-]+$/;
    return regex.test(input);
}

export function validateString(input) {
    if (input && input !== "") {
        const regex = /^\d+(?:-\d+)?$/;
        if (!regex.test(input)) return "Invalid format. Only numbers and a single hyphen are allowed.";

        const parts = input.split('-');
        if (parts.length === 2) {
            const num1 = parseInt(parts[0], 10);
            const num2 = parseInt(parts[1], 10);
            if (num1 >= num2) return "First value must be less than second value.";
        }
    }
    return ""
}

export async function shareToSocialMedia(platform, domain, setClicked, setClickedBtn) {
    const description = "Take the stress out of shipping and focus on growing your business. Let your store work smarter!"
    const hashtags = "OnlineStoreSuccess,ShopifyExperts,StoreOptimization,EcommerceWins,SmartBusiness"
    const pageUrl = `https://apps.shopify.com/${APP_PATH}`;
    const pageTitle = encodeURIComponent(APP_NAME)
    const encodedDesc = encodeURIComponent(description); // extra message
    let shareUrl = '';
    if (setClicked) {
        setClicked(true)
    }
    if (setClickedBtn) {
        setClickedBtn(platform)
    }
    switch (platform) {
        case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&quote=${encodedDesc}`;
            break;
        case 'twitter':
            shareUrl = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}%20-%20${encodedDesc}&hashtags=${hashtags}`;
            break;
        case 'linkedin':
            // shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}&title=${pageTitle}&summary=${encodedDesc}`;
            shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}&title=${pageTitle}&summary=${encodedDesc}&source=Logic%2CEverest`;
            break;
        case 'whatsapp':
            // For WhatsApp, it's common to share text and URL combined
            shareUrl = `https://wa.me/?text=${pageTitle}%20-%20${encodedDesc}%20${pageUrl}`;
            break;
        default:
            console.error('Unsupported social media platform.');
            return;
    }
    window.open(shareUrl, '_blank', 'width=600,height=400,resizable=yes,scrollbars=yes');
}

export const checkEnabled = (shop_id, setChecking, dispatch, fetchJson) => {
    if (!fetchJson) {
        console.log("fetchJson is required to check enabled status.");
        return;
    }
    setChecking(true)
    fetchJson(`/settings/ccs?shop_id=${shop_id}`, {
        method: 'GET'
    }).then(response => {
        setChecking(false)
        if (response?.status >= 500) {
            dispatch(setToast({ active: true, content: "Server Error", error: true }))
        } else {
            dispatch(ShowWarning(response.show_warning))
            dispatch(setToast({ active: true, content: response.message }))

        }
    }).catch(error => {
        setChecking(false)
        dispatch(setToast({ active: true, content: error.message, error: true }))
    })
}

export const verifySharing = async (userInput, clickedBtn) => {
    if (!userInput || typeof userInput !== "string") {
        return { valid: false, reason: "Invalid input" };
    }

    let extractedUrl = null;

    // --- Facebook (iframe src) ---
    if (clickedBtn === constants.facebook) {
        const match = userInput.match(/src="([^"]*facebook\.com[^"]*)"/);
        if (match) {
            const params = new URL(match[1]).searchParams;
            extractedUrl = params.get("href"); // real fb post url
        }
    }

    // --- Twitter (blockquote with status link) ---
    if (clickedBtn === constants.twitter) {
        const match = userInput.match(/https?:\/\/twitter\.com\/[^/]+\/status\/\d+/);
        if (match) {
            extractedUrl = match[0];
        }
    }

    // --- LinkedIn (iframe src) ---
    if (clickedBtn === constants.linkedin) {
        const match = userInput.match(/src="([^"]*linkedin\.com\/embed\/feed\/update\/urn:li:share:\d+[^"]*)"/);
        if (match) {
            extractedUrl = match[1].replace("/embed", ""); // convert embed → real post
        }
    }

    return {
        valid: !!extractedUrl,
        platform: clickedBtn,
        url: extractedUrl
    };

    // const options = {
    //     "url": 'https://hook.eu2.make.com/vx7j07p4nebp4htw4g1dnglshj4vibal',
    //     "method": 'POST',
    //     "data": { url: src },
    // }
    // try {
    //     const response = await axios.request(options)
    //     return true
    //     // console.log(response.data);
    //     // const url = "https://apps.shopify.com/advancedshippingrates";
    //     // const found = response.data.includes(url) ? url : null;
    //     // console.log("found", found);

    // } catch (error) {
    //     console.log(error.message);
    //     console.log(error.response?.data);
    //     return "Invalid embedd code"
    // }
}
export const authenticateShop = async (shop) => {
    if (shop) {
        try {
            const shopRes = await axios({ method: "GET", url: `/auth/app?shop=${shop}` })
            if (!shopRes.data.isActive) {
                const url = `https://${shop}/admin/oauth/authorize?client_id=${process.env.REACT_APP_SHOPIFY_API_KEY}&scope=write_shipping,read_shipping,read_locations,read_orders&state=174704764207900&redirect_uri=https://${window.location.host}/callback`
                window?.open(url, "_top")
            } else {
                return shopRes.data.isActive
            }
        } catch (error) {
            console.log(error.message);
            return false
        }
    }
}

export const formatCurrency = currency => currency?.replace("{{amount}}", "")

export function validateRate(Rate, checkout_ui = false, toast) {
    let errors = {};
    let isError = false;

    // Config-based validation
    const rules = {
        display_name: (val) =>
            !val || val.trim() === "" ? "This field is required" : "",

        default_cost: (val, rate) =>
            (rate.charge_by === "no" || (rate.charge_by !== "no" && rate.add_base_price === true)) &&
                (!val || val.trim() === "")
                ? "This field is required"
                : "",


        description: (val) =>
            val && val.length > 255 ? "Maximum 255 characters allowed" : "",

        charge_by: (val, rate) =>
            val !== "no" && (!rate.shipping_ranges || rate.shipping_ranges.length === 0)
                ? "At least one range is required."
                : "",

        delivery: (val) =>
            checkout_ui ? validateString(val) : "",
    };

    // Location-specific rules
    const locationRules = {
        zip: (rate) =>
            !rate.zip_codes || rate.zip_codes.length === 0
                ? "Zip codes are required"
                : "",
        city: (rate) =>
            !rate.cities || rate.cities.length === 0
                ? "Cities are required"
                : "",
        state: (rate) =>
            !rate.states || rate.states.length === 0
                ? "States are required"
                : "",
        countries: (rate) =>
            !rate.countries || rate.countries.length === 0
                ? "Countries are required"
                : "",
    };

    // Run through keys
    for (const key in Rate) {
        if (key === "shipping_by" && locationRules[Rate[key]]) {
            const message = locationRules[Rate[key]](Rate);
            if (message) {
                errors[Rate[key] + (Rate[key] === "zip" ? "_codes" : "s")] = message;
                isError = true;
            }
        } else if (rules[key]) {
            const message = rules[key](Rate[key], Rate);
            if (message) {
                if (key === "charge_by") {
                    toast.content = message; // special toast
                }
                errors[key] = message;
                isError = true;
            }
        }
    }

    return { isError, errors };
}

export function toQueryString(obj) {
    return "?" + Object.entries(obj)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');
}

